// extracted by mini-css-extract-plugin
export default {"container":"oALh3szogVbw8dr55wPE","layout-simple":"z5gNHljfAmt0ctdLmwPH","layout-grid":"LkNzPZqBy79kCW23eCk0","layout-flex":"DuOz59bVdskOUsFB_OTY"};